import { Component } from '@angular/core';

@Component({
  selector: 'mc-race',
  templateUrl: './race.component.html',
  styleUrls: ['./race.component.scss']
})
export class RaceComponent {

  constructor(
  ) { }
}
